export const createApiStrFilterExpr = ({
  values,
  filterExpr = 'Id'
}: {
  values: (string | number | boolean)[];
  filterExpr?: string;
}) => {
  return values.reduce<string>((prevVal, val, index, arr) => {
    const valFilterWType = typeof val === 'string' ? `'${val}'` : val;

    const valFilter = `${prevVal}(${filterExpr} eq ${valFilterWType})`;

    if (index !== arr.length - 1) {
      return `${valFilter} or `;
    }

    return valFilter;
  }, '');
};
